<template>
<div class="captail_wrap registrationSteps position-relative fullLoader p-0 w-100">
	<loader v-if="pageLoader"></loader> 
    <div class="middle_section m-0">
        <div class="top_searchbars">
            <div class="row">
                <div class="col-12">
                    <div class="cap_logo_steps centerLogo p-3 d-flex justify-content-between align-items-center">
						 <router-link to="/home"><img src="../../../../../static/website/images/logo.svg" alt="Captail wallet"></router-link>
						<div class="rightBack d-flex align-items-center">
						<router-link class="backToDash mr-2" :to="'/individual-step2'"><feather type="chevron-left"></feather></router-link>
						<router-link class="backToDash" :to="'/home'"><feather type="home"></feather></router-link>
						</div>
					</div>
                </div>
            </div>
        </div> 
		
		<div class="d-flex justify-content-center motAroow" v-if="continueMobileOption">
			<section class="stepsForm-include valigncenter border-0 max-1440 mx-auto w-100">
                <div class="row justify-content-center w-100 mx-0">
                    <div class="col-12 col-lg-6 stepBorder box-shadow mobPad text-center">
						<!--<input type="text" placeholder="enter your email ">
						<a href="#">Submit</a>-->			
						<h3 class="incMob mb-left mb-4">Scan QR code instead </h3>
						<p>Scan this QR code using your mobile camera or QR code app </p>
						<div class="scanInfo d-flex align-items-center text-left mt-4">
							<!---<vue-qrcode :value="'https://dev.finvasia.com:8092/?token='+get_user.token" />--->
							<vue-qrcode :value="$env_var.qrCodeLink + get_user.token" />
							<p><feather size="16px" type="alert-triangle"></feather> Please keep this page open while you are using your mobile</p>
						</div>
						<a class="clooseIT-circle cap_btn redBG px-4 large_btn mt-4" href="#" @click="ContinueMobileBrowser(false); stepInfo()">Continue with Browser</a>
					</div>
				</div>
			</section>
			
		</div>
        <div class="abSxt" v-else>
        	<div class="contact_withPhone">
				<a class="d-flex align-items-center" href="#" @click="continueMobileOption = true "><feather size="18px" type="smartphone"></feather> <span>Continue with mobile</span></a>
			</div>
		<div class="mid_scroll_content d-flex justify-content-center">
            <section class="stepsForm-include valigncenter border-0 max-1440 mx-auto w-100">
                <div class="row justify-content-center w-100 mx-0">
                  <div class="col-12 col-md-10 mobPad">

                  	<alert-notification v-if="notification_msg != ''"/>
					<form data-toggle="validator" method="post" enctype="multipart/form-data" id="individualForm" v-on:submit.prevent="submitIndividual()">
						<div class="row justify-content-center mx-0 w-100 mobleft-text">
							<div class="col-12 col-lg-10 text-center" v-if="showTab == index && (index == 0 || index == 1)" v-for="(value, key, index) in documentsByName">
								<h3 class="text-center incMob mb-left mtmOb mb-4" v-if="index == 0">IDENTITY DOCUMENTS</h3>
								<h3 class="text-center incMob mb-left mtmOb mb-4" v-if="index == 1">PROOF OF RESIDENCE DOCUMENTS</h3>
								<div>
									<p class="mb-left mtmOb" v-if="index == 0">Upload a photo of your identity document. Please ensure that the details on the ID matches with the information you entered in the personal information form. </p>
									<p class="mb-left mtmOb" v-if="index == 1">Upload a proof of your residence address (in your name & not more than 6 months old). Please note that we do not accept screenshots.</p>
									
									<div class="proofIdenty text-left" >										
										<div class="d-flex align-items-center justify-content-end mt-4 mb-3">
											<!-- <h4>Choose your document type</h4> -->
											<div class="oneFive d-flex justify-content-end">
												<p class="mb-2">{{index + 1}} out of 3 Documents</p>
											</div>
										</div>
										<div class="identiyUL row" >
											<div class="col-12" v-for="(val, key1) in fileNames[key]" :class=" tabEnableDisable(key,key1)">
												<div class="whiteBG regulate text-center" @click="clearData(key,key1); fileName = key1" :class="[{'active':(key1 == fileName)}]">
													<div class="iconModify">
														<img :src="'../../../../../static/website/images/'+doc_ico[key1]+'.svg'" alt="Icon">	
													</div>
													<p>{{val}}</p>
												</div>
											</div> 
										</div>
										
										<div class="customTabs-acc boxShadow d-none p-3 border-radius-10 mt-2 mx-0 active" v-if="fileName != '' && double_allow.includes(fileName)">
											<div class="row m-0">
												<div class="col-12 mt-1">
												
													<div class="flotil db2">
														
														<span class="moduleMob">
															<h5 class="mb-2" v-if="fileName == 'Drivers_License'">Take the photo of your Driver’s License here</h5>
															<h5 class="mb-2" v-if="fileName == 'Government_Issued_Photo_ID'">Take the photo of your Government Issued ID here</h5>
															<p class="f-14  mb-1"><strong>Good quality:</strong> Bright and clear</p>
															<p class="f-14"><strong>Note:</strong> All corners of the document should be visible</p>
														</span>
														<div class="findidentity row mt-4">
															<div class="col-12 col-md-4">
																<div class="cornerInc">
																	<span class="boxColred good hideMobile">
																		<img src="../../../../../static/website/images/group-5.svg" alt="Icon">
																	</span>
																</div>
															
															</div>
															<div class="col-12 col-md-4">
																<div class="cornerInc">
																	<span class="boxColred bad mid hideMobile">
																		<img class="wrong" src="../../../../../static/website/images/group-7.svg" alt="Icon">
																		<img src="../../../../../static/website/images/crossSv.svg" alt="Icon" class="crossSV">
																	</span>
																</div>
																
															</div>
															<div class="col-12 col-md-4">
																<div class="cornerInc">
																	<span class="boxColred bad small hideMobile">
																		<img class="wrong" src="../../../../../static/website/images/group-7.svg" alt="Icon">
																		<img src="../../../../../static/website/images/crossSv.svg" alt="Icon" class="crossSV">
																	</span>
																</div>
																
															</div>
														</div>
													</div>
												</div>
												<div class="col-12 mt-4">
													<div class="row mob-mx-0">
														<div class="col-12 col-lg-6">
															<div class="upload-btn-wrapper idenCopy-upload w-100">
																<div v-if="documentJsonData[key] != undefined && documentNameSHowFuncUnderTab(key,'FRONT')">
																
																<div class="showResult"  v-for="val in documentJsonData[key]" v-if="val.document_name.includes('FRONT')">
																	<a class="" :href="$env_var.docsLink+'user&id='+get_user.profile.user_id+'&doc='+ val.name" target="_blank()" >
																		<vue-pdf height= "50px" v-if="val.name.split('.')[val.name.split('.').length -1].toLowerCase() == 'pdf'" :src="$env_var.docsLink+'user&id='+get_user.profile.user_id+'&doc='+ val.name" />
																		<img height= "50px" v-else :src="$env_var.docsLink+'user&id='+get_user.profile.user_id+'&doc='+ val.name" />
																	</a>
																  	<a class="customClose" href="#"> 
																	<feather type="trash-2"  :class="(pageLoader)?'disabled':''" v-on:click.stop.prevent="deleteFunc(key,val.id)"></feather></a>
															  	</div>
																</div>
																<div v-else>
																	<div class="inbit" v-if="check_img(value.data,'front',fileName)" :class="documentenabledisable(key,'FRONT',fileName)">
																		<div class="btn outerWrapper pt-4 w-100">
																			<h4>Upload the front of your document</h4>
																		  
																			<button class="btn d-inline-flex align-items-center"><feather size="14px" type="plus-circle" class="mr-2"></feather> Upload</button>
																			<p class="mxSixe">Maximum files size of can be uploaded up to {{$env_var.fileSize.individualSize}} {{$env_var.fileSize.type}}</p>
																		</div>
																	  <input type="file" name="myfile" id="front" @change="addMoreFileChange( $event.target.files[0], key , 'front')" />
																	</div>
																	<!--UploadImage-->
																	<div class="showResult" v-for="(val,ind) in value.data" v-if="value.data.length >0 && val.type == 'front' && val.fileName == fileName">
																		<vue-pdf v-if="val.name != '' && val.file.type == 'application/pdf'" :src="addfileImage(val.file)" />
																		<img :src="addfileImage(val.file)" alt="Icon">
																		<a class="customClose" href="#"><feather size="18px" type="x" @click.prevent="clearFileAddMore(key,ind)"></feather> </a>
																	</div>
																</div>
															</div>
														</div>
														<div class="col-12 col-lg-6">
															<div class="upload-btn-wrapper idenCopy-upload w-100">
																<div v-if="documentJsonData[key] != undefined && documentNameSHowFuncUnderTab(key,'BACK')">
																	<div class="showResult"  v-for="val in documentJsonData[key]" v-if="val.document_name.includes('BACK')">
																		<a class="" :href="$env_var.docsLink+'user&id='+get_user.profile.user_id+'&doc='+ val.name" target="_blank()" >
																			<vue-pdf height= "50px" v-if="val.name.split('.')[val.name.split('.').length -1].toLowerCase() == 'pdf'" :src="$env_var.docsLink+'user&id='+get_user.profile.user_id+'&doc='+ val.name" />
																			<img height= "50px" v-else :src="$env_var.docsLink+'user&id='+get_user.profile.user_id+'&doc='+ val.name" />
																		</a>
																		<a class="customClose" href="#"> 
																		<feather type="trash-2"  :class="(pageLoader)?'disabled':''" v-on:click.stop.prevent="deleteFunc(key,val.id)"></feather></a>
																	</div>
																</div>
																<div v-else>
																	<div class="inbit" v-if="check_img(value.data,'back',fileName)" :class="documentenabledisable(key,'BACK',fileName)">
																		<div class="btn outerWrapper pt-4 w-100">
																			<h4>Upload the back of your document</h4>
																			
																			<button class="btn d-inline-flex align-items-center"><feather size="14px" type="plus-circle" class="mr-2"></feather> Upload</button>
																			<p class="mxSixe">Maximum files size of can be uploaded up to {{$env_var.fileSize.individualSize}} {{$env_var.fileSize.type}}</p>
																		</div>
																		<input type="file" name="myfile" id="back" @change="addMoreFileChange( $event.target.files[0], key , 'back')" />
																	</div>
																	<div class="showResult" v-for="(val,ind) in value.data" v-if="value.data.length >0 && val.type == 'back' && val.fileName == fileName">
																		<vue-pdf v-if="val.name != '' && val.file.type == 'application/pdf'" :src="addfileImage(val.file)" />
																		<img :src="addfileImage(val.file)" alt="Icon">
																		<a class="customClose" href="#"><feather size="18px" type="x" @click.prevent="clearFileAddMore(key,ind)"></feather> </a>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										
										<div class="customTabs-acc boxShadow d-none p-3 border-radius-10 mt-2 mx-0 active" v-if="fileName != '' && !double_allow.includes(fileName)">
											<div class="row m-0">
												<div class="col-12 mt-1">
													<div class="flotil" v-if="index == 0">
														<span class="moduleMob">
															<h5 class="mb-2" v-if="fileName == 'Passport'">Take a photo of your Passport here</h5>
															<p class="f-14 mb-1"><strong>Good quality:</strong> Bright and clear</p>
															<p class="f-14"><strong>Note:</strong> All corners of the document should be visible</p>
														</span>
														<div class="findidentity row mt-4">
															<div class="col-12 col-md-4">
																<div class="cornerInc">
																	<span class="boxColred good hideMobile">
																		<img src="../../../../../static/website/images/group-5.svg" alt="Icon">
																	</span>
																</div>
															
															</div>
															<div class="col-12 col-md-4">
																<div class="cornerInc">
																	<span class="boxColred bad mid hideMobile">
																		<img class="wrong" src="../../../../../static/website/images/group-7.svg" alt="Icon">
																		<img src="../../../../../static/website/images/crossSv.svg" alt="Icon" class="crossSV">
																	</span>
																</div>
																
															</div>
															<div class="col-12 col-md-4">
																<div class="cornerInc">
																	<span class="boxColred bad small hideMobile">
																		<img class="wrong" src="../../../../../static/website/images/group-7.svg" alt="Icon">
																		<img src="../../../../../static/website/images/crossSv.svg" alt="Icon" class="crossSV">
																	</span>
																</div>
																
															</div>
														</div>
													</div>
													<div class="flotil" v-if="index == 1">
														<span class="moduleMob">
															<h5 class="mb-1">Take a photo of your Residence proof (not more than 6 months old). The photo should be:</h5>
															<p>Bank Statement, Utility Bill, Payroll Statement or Tax Document</p>
														</span>
														<div class="findidentity row mt-12">
															<div class="col-12 col-md-12">
																<div class="cornerInc">
																	<span class="boxColred good">
																		<img src="../../../../../static/website/images/group-5.svg" alt="Icon">
																	</span>
																</div>
																<p class="f-14"><strong>Note:</strong> All corners of the document should be visible</p>
															</div>
														</div>
													</div>
												</div>
												<div class="col-12 mt-4">
													<div class="row mob-mx-0 justify-content-center">
														<div class="col-12 col-lg-6">
															<div class="upload-btn-wrapper idenCopy-upload w-100">
																<div v-if="documentJsonData[key] != undefined && documentNameSHowFuncUnderTab(key,'single')">
																<div class="showResult"  v-for="val in documentJsonData[key]">
																	<a class="" :href="$env_var.docsLink+'user&id='+get_user.profile.user_id+'&doc='+ val.name" target="_blank()" >
																		<vue-pdf height= "50px" v-if="val.name.split('.')[val.name.split('.').length -1].toLowerCase() == 'pdf'" :src="$env_var.docsLink+'user&id='+get_user.profile.user_id+'&doc='+ val.name" />
																		<img height= "50px" v-else :src="$env_var.docsLink+'user&id='+get_user.profile.user_id+'&doc='+ val.name" />
																	</a>
																  	<a class="customClose" href="#"> 
																	<feather type="trash-2"  :class="(pageLoader)?'disabled':''" v-on:click.stop.prevent="deleteFunc(key,val.id)"></feather></a>
															  	</div>
																</div>
																<div v-else>
																	<div class="showResult" v-for="(val,ind) in value.data" v-if="value.data.length >0  && val.fileName == fileName">
																		<vue-pdf v-if="val.name != '' && val.file.type == 'application/pdf'" :src="addfileImage(val.file)" />
																		<img  v-else-if="val.name != ''" :src="addfileImage(val.file)" alt="Icon">
																		<a class="customClose" href="#"><feather size="18px" type="x" @click.prevent="clearFileAddMore(key,ind)"></feather> </a>
																	</div>
																	
																	<div class="inbit"  :class="documentenabledisable(key,'',fileName)" v-if="value.data.length == 0  ">
																		<div class="btn outerWrapper pt-4 w-100">
																			<h4>Upload your document</h4>
																		  
																			<button class="btn d-inline-flex align-items-center"><feather size="14px" type="plus-circle" class="mr-2"></feather> Upload</button>
																			<p class="mxSixe">Maximum files size of can be uploaded up to {{$env_var.fileSize.individualSize}} {{$env_var.fileSize.type}}</p>
																		</div>
																		<input type="file" name="document[]" :id="key" :ref="key" @change="addMoreFileChange( $event.target.files[0], key,key)" />
																	</div>
																</div>
															</div>
														</div>
														
													</div>
												</div>
											</div>
										</div>
										
									</div>
								</div>
								
								
								

								<div class="loopUpload mt-4" v-show="fileName != ''">
									<!-- All files size error msz -->
									<div class="alert alert-danger d-flex align-items-center justify-content-between" role="alert" v-if="totalSizeErrMsg">files size can be maximum {{$env_var.fileSize.totalSize}} {{$env_var.fileSize.type}} <feather type="x" @click="totalSizeErrMsg = false"></feather></div>
									<!-- single files size error msz -->
									<div class="alert alert-danger d-flex align-items-center justify-content-between" role="alert" v-if="individualSizeErrMsg">files size can be maximum {{$env_var.fileSize.individualSize}} {{$env_var.fileSize.type}} <feather type="x" @click="individualSizeErrMsg = false"></feather></div>
									<div class="alert alert-danger d-flex align-items-center justify-content-between" role="alert" v-if="extensionType">Only jpg, jpeg, png, pdf files are allowed! <feather type="x" @click="extensionType = false"></feather></div>
								</div>
								<div class="alert alert-danger d-flex align-items-center justify-content-between" role="alert" v-if="docValidation">Field is required. Select at least one to upload 
									<feather type="x" @click="docValidation = false"></feather>
								</div>
								
								
								
								<div class="submitButton text-center mt-4 pb-4 mobRotate">
									<input type="button" class="backButton" value="Back" v-if="index != 0" :class="(pageLoader)?'disabled':''"  @click.prevent.stop="backButton()">
									<input type="submit" class="cap_btn blue px-4 large_btn" value="Next" :class="(pageLoader)?'disabled':''">
								</div>
							</div>
							
							
							
							<div v-if="showTab == 2"><!-- noCamera-{{noCamera}}-docValidation-{{docValidation}}-isCameraOpen-{{!isCameraOpen}} -->
								<div class="alert alert-danger d-flex align-items-center justify-content-between" role="alert" v-if="noCamera">May the browser didn't support or there is some errors. so please upload file <feather type="x" @click="noCamera = false"></feather></div>
								<div class="alert alert-danger d-flex align-items-center justify-content-between" role="alert" v-if="cameraNotAllow">Camera permission denied <feather type="x" @click="cameraNotAllow = false"></feather></div>
								<div class="alert alert-danger d-flex align-items-center justify-content-between" role="alert" v-if="docValidation">Field is required. Select at least one to upload <feather type="x" @click="docValidation = false"></feather></div>
								<div class="card stepBorder box-shadow w-100 webcam">
									<div class="card-header  bg-transparent">
										<h4 class="card-title m-0">PHOTO VERIFICATION</h4>
									</div>
									<div class="card-body pt-4 pb-4 pl-3 pr-3">
										<div class="row mx-0 mt-3">
											<div class="col-12 col-lg-6 mobPad">
												<p class="pb-3">All users are required to upload a Verification photo. This is just part of the numerous techniques and systems we employ to ensure the legitimacy of our users.</p>
												<div class="uploadRegt">
													<h4 class="mb-2">Your otp is :<span>{{otp}}</span></h4>
													<p class="mb-0">Please upload a photo of yourself holding a hand written paper with the content below:</p>
												</div>
												
												<h5>For Capital Wallet</h5>
												<p class="mb-1">Full Name: <strong v-if="get_user.profile.firstname != ''">{{get_user.profile.firstname}} {{get_user.profile.middlename}}{{get_user.profile.lastname}}</strong > <strong v-else>{{ username}}</strong ></p>
												<p class="mb-1">OTP: <strong>{{otp}}</strong></p>
												<p class="mb-2">Your Signature: -------------</p>
												<p class="mb-0">Today's Date: -------------</p><br>
												<p>Please ensure that  your face, code and signature are clearly visible. </p> 
											</div>
											<div class="mobPad col-lg-6 col-12 pl-md-5 text-center">
												<div class="file-uploader custmSelfie" v-if="upload_options">
													<img class="selfiIcon" src="../../../../../static/website/images/2968338.svg" alt="Captail wallet">
													<span class="cap_btn small px-4 large_btn" @click="openCam();upload_options = false">Start</span>
													<br>
													<span class="noWebcam" @click="file_upload = true;upload_options = false">I don't have Web Cam</span>
												</div>
												<div class="file-uploader webCapture" v-show="isCameraOpen && !file_upload">
													<div>
														<div v-show="!isLoading" class="camera-box afterCLick mb-4" :class="{ 'flash' : isShotPhoto }">
															<div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
															<video v-show="!isPhotoTaken" ref="camera"  height="200px" autoplay></video>
															<canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas"  width="200px" height="200px"></canvas>
															
															<div class="timercon" v-if="timer > 0">{{timer}}</div>
														</div>
														<div v-if="isLoading" class="camera-box openCamera mb-4">
															<div class="timercon">
															 <img src="../../../../../static/website/images/loader.gif" alt="Icon">	
															</div>
														</div>
														<input type="hidden" id="canvasimg" name="canvasimg" />
														<div v-if="!isPhotoTaken && !isLoading && timer == 0" class="camera-shoot mb-3">
															<span class="cap_btn blue px-4 large_btn" @click="countDown()">Capture Image</span>
														</div>
														<span class="cursor" @click="closeCam()">Cancel</span><!--  v-show="isPhotoTaken" -->
													</div>
												</div>
												<div v-if="file_upload">
													<div class="alert alert-danger d-flex align-items-center justify-content-between" role="alert" v-if="individualSizeErrMsg">files size can be maximum {{$env_var.fileSize.individualSize}} {{$env_var.fileSize.type}} <feather type="x" @click="individualSizeErrMsg = false"></feather></div>
													<div class="file-uploader loopUpload position-relative ste6">
														<label for="ipv_document" class="form_label"><span class="themecolor">Choose File To upload</span></label>
														<input type="file" id="ipv_document" class="file-upload" name="document[]" ref="Photo_Verification" @change="onFileChange('Photo_Verification', $event.target.files[0])" />
														<div v-if="documentsByName.Photo_Verification.data[0].name != ''" class="attachmenttSatus">
															<vue-pdf v-if="documentsByName.Photo_Verification.data[0].name != '' && documentsByName.Photo_Verification.data[0].file.type == 'application/pdf'" :src="addfileImage(documentsByName.Photo_Verification.data[0].file)" />
															<img v-else-if="documentsByName.Photo_Verification.data[0].name != ''" :src="addfileImage(documentsByName.Photo_Verification.data[0].file)"/>
															<span class="deletedoc"><!-- {{documentsByName.ipv_document.data[0].name}} --> 
																<feather type="x" @click="documentsByName.Photo_Verification.data[0].name = ''"></feather>
															</span> 
														</div>
														<p>Maximum files size of can be uploaded up to {{$env_var.fileSize.totalSize}} {{$env_var.fileSize.type}}</p>
													</div>
													<div>or</div>
													<span class="cap_btn blue d-inline-block mt-2 large_btn" @click="file_upload = false;upload_options = true;documentsByName.Photo_Verification.data[0].name = ''">Use Web Cam</span>
												</div>
												<div class="verfiyITV"v-if="(isCameraOpen)?isPhotoTaken:!isCameraOpen">
													<a href="javascript:void(0)" class="red mr-3" @click.prevent.stop="showTab = 1;closeCam();faliNameChange()">
														Back
													</a>
													<input type="submit" class="cap_btn blue px-4 large_btn" :class="(pageLoader)?'disabled':''" value="Submit" name="" required="">
												</div>
											</div>
											<div class="col-lg-6 mobPad col-12 uploadProof-row p-3 d-flex justify-content-between align-items-center"  v-if="documentJsonData['Photo_Verification'] != undefined">
												<div class="attachmenttSatus-proof" v-for="val in documentJsonData['Photo_Verification']">
													<a class="UploadedProof" :href="$env_var.docsLink+'user&id='+get_user.profile.user_id+'&doc='+ val.name" target="_blank()" >
														<vue-pdf height= "50px" v-if="val.name.split('.')[val.name.split('.').length -1].toLowerCase() == 'pdf'" :src="$env_var.docsLink+'user&id='+get_user.profile.user_id+'&doc='+ val.name" />
														<img height= "50px" v-else :src="$env_var.docsLink+'user&id='+get_user.profile.user_id+'&doc='+ val.name" />
													</a>
													<a class="delete blue" href="#" :class="(pageLoader)?'disabled':''"  v-on:click.stop.prevent="deleteFunc('Photo_Verification',val.id)">
														<feather type="trash-2"></feather>
													</a>
												</div>
												<div class="bckButton">
													<button class="cap_btn blue px-4" @click.prevent.stop="showTab = 1">
														back
													</button>
												</div>
											</div>
											
										</div>
									</div>
								</div>
							</div>
						</div>
					</form>
				   </div>
                </div>
            </section>
        </div>
        </div>
    </div>
</div>
</template>

<script>
import { registerStepsMixins } from '@/plugins/registerSteps'
import VueQrcode from 'vue-qrcode'
import * as types from '@/types'
import { mapActions } from 'vuex'
export default {
    name: 'step-six',
	mixins: [registerStepsMixins],
    data() {
        return {
			pageLoader : false,
			continueMobileOption : false,
			notification_msg:'',
            notification_type:'',
			submitted : false,
			doc_array : [],
			identity_document : '',
			govt_document2 : '',
			govt_document3 : '',
			brand_file_request : '',
			showTab : 0,

			upload_options : true,
			file_upload : false,

			setUpFxaccount: false,
			isCameraOpen: false,
            isPhotoTaken: false,
			isShotPhoto: false,
			isLoading: false,
			file4:'',
			timer: 0,
			fileNames:{
				'Proof_of_Identity' :{
					'Passport':'Passport',
					'Drivers_License':'Drivers License',
					'Government_Issued_Photo_ID':'Government Issued Photo ID',
				},
				'Proof_of_Residence' :{
					'Bank_Credit_Card_Statement':'Bank Statement/Credit Card Statement',
					'Utility_Bill':'Utility Bill',
					'Payroll_Statement':'Payroll Statement',
					'Tax_Document':'Tax Document'
				}
			},
			doc_ico:{
				'Passport' : 'Group-3',
				'Drivers_License' : 'Group-2',
				'Government_Issued_Photo_ID' : 'Group-4',
				'Bank_Credit_Card_Statement' : 'Group-3',
				'Utility_Bill' : 'Group-2',
				'Payroll_Statement' : 'Group-4',
				'Tax_Document' : 'Group-4'
			},
			double_allow:['Drivers_License','Government_Issued_Photo_ID'],
			fileName:'Passport',
			documentJsonData : {},
			documentsByName:{
				'Proof_of_Identity' : {description : '', data:[]},
				'Proof_of_Residence' : {description : '', data:[]},
				'Photo_Verification' : {description : '', data:[]}
			},
			lengthErrMsg: false,
			totalSizeErrMsg : false,
			individualSizeErrMsg : false,
			noCamera: false,
			cameraNotAllow: false,
			docValidation: false,
			otp:'',
			username: '',
			chngedelFun : false,
			extensionAllw : ['jpg', 'jpeg', 'png', 'pdf'],
			extensionType : false
		}
	},
	components: {
		VueQrcode,
	},
	methods: {
		...mapActions({
			_runstateLoad: types.RUN_STATE_LOAD
		}),
		clearData(key,key1){
			if(this.fileName != key1){
				this.documentsByName[key].data = []
			}
			/*this.documentsByName = {
				'Proof_of_Identity' : {description : '', data:[]},
				'Proof_of_Residence' : {description : '', data:[]},
				'Photo_Verification' : {description : '', data:[]}
			}*/
		},
		tabEnableDisable(key, key1){
			let fileName1 = key1
			if(key1.includes("_")){
				fileName1 = key1.split('_')[0]
			}
			let data = ((Object.keys(this.fileNames[key]).length == 3)? 'col-md-4':'col-md-3')
			
			if(Object.keys(this.documentJsonData).length > 0){
				if(this.documentJsonData[key] && this.documentJsonData[key] !== 'undefined'){
				
					if(this.documentJsonData[key][0].document_name.includes(fileName1)){
						this.fileName = key1
						return 'enable '+data
					}else{
						return 'disable '+data
					}
				}else{
					return 'enable '+data
				}
			}else{
				return 'enable '+data
			}
		},
		documentNameSHowFuncUnderTab(key,getdocType){
			let fileName1 = this.fileName
			if(getdocType == 'single'){
				
				if(this.fileName.includes("_")){
					fileName1 = this.fileName.split('_')[0]
				}
				if(this.documentJsonData[key].length == 1){
					if(this.documentJsonData[key][0].document_name.includes(fileName1)){
						return true;
					}else{
						return false;
					}
				}else{
					return false;
				}
			}else if(getdocType == 'BACK'){
				if(this.fileName.includes("_")){
					fileName1 = this.fileName.split('_')[0]
				}
				if(this.documentJsonData[key].length == 1){
					if(this.documentJsonData[key][0].document_name.includes(fileName1) && this.documentJsonData[key][0].document_name.includes(getdocType)){
						return true;
					}else{
						return false;
					}
				}else if(this.documentJsonData[key].length == 2){
					
					let i = '';
					if(this.documentJsonData[key][0].document_name.includes(fileName1) && this.documentJsonData[key][0].document_name.includes(getdocType)){
					
						i = 1
					}
					if(this.documentJsonData[key][1].document_name.includes(fileName1) && this.documentJsonData[key][1].document_name.includes(getdocType)){
					
						i = 1
					}
					
					if(i == 1){
						return true;
					}else{
						return false;
					}
				}else{
					return false;
				}
				
			}else if(getdocType == 'FRONT' ){
			
				if(this.fileName.includes("_")){
					fileName1 = this.fileName.split('_')[0]
				}
				if(this.documentJsonData[key].length == 1){
					if(this.documentJsonData[key][0].document_name.includes(fileName1) && this.documentJsonData[key][0].document_name.includes(getdocType)){
						return true;
					}else{
						return false;
					}
				}else if(this.documentJsonData[key].length == 2){
					
					let i = '';
					if(this.documentJsonData[key][0].document_name.includes(fileName1) && this.documentJsonData[key][0].document_name.includes(getdocType)){
						i = 1
					}
					if(this.documentJsonData[key][1].document_name.includes(fileName1) && this.documentJsonData[key][1].document_name.includes(getdocType)){
						i = 1
					}
					
					if(i == 1){
						return true;
					}else{
						return false;
					}
				}else{
					return false;
				}
				
			}
			
		},
		documentenabledisable(key,getType,getFileName){
			let fileName1 = getFileName
			if(getFileName.includes("_")){
				fileName1 = getFileName.split('_')[0]
			}
			if(this.documentJsonData[key] && this.documentJsonData[key] !== 'undefined'){
				if(Object.keys(this.documentJsonData[key]).length == 0){
					return 'enable'
				}else if(Object.keys(this.documentJsonData[key]).length == 1){
					if((this.documentJsonData[key][0].document_name.includes("FRONT") || this.documentJsonData[key][0].document_name.includes("BACK")) && getType != '' && this.documentJsonData[key][0].document_name.includes(fileName1)){
						if(this.documentJsonData[key][0].document_name.includes("FRONT") && getType == 'FRONT'){
							return 'disable'
						}else if(this.documentJsonData[key][0].document_name.includes("BACK") && getType == 'BACK'){
							return 'disable'
						}else{
							return 'enable'
						}
					}else{
						return 'disable'
					}
				}else if(Object.keys(this.documentJsonData[key]).length > 1){
					return 'disable'
				}
			}else{
				return 'enable'
			}
		},
		ImageOtpSent(){
			this._runGetImageOtp({'globalParams' :{ },'localParams' :{ "parameter" : this}})
		},
        addfileImage(file){
            return URL.createObjectURL(file);
        },
		clearFileAddMore(docType,index){
			this.documentsByName[docType].data.splice(index, 1);
			this.lengthErrMsg = false
			this.totalSizeErrMsg = false
			this.individualSizeErrMsg = false
        },
        check_img(data,type,fileName){
        	// console.log(data,type,fileName)
        	return data.filter(val=>{ return (val.type == type && val.fileName == fileName)}).length == 0
        },
        addMoreFileChange(file,docType,type){
			
			this.docValidation = false
			this.extensionType = false
			let length = this.documentsByName[docType].data.length
			length += (this.documentJsonData[docType] != undefined) ? this.documentJsonData[docType].length : 0
			if(length == 5){
				this.lengthErrMsg = true
				
			}else if( file.size / this.$env_var.fileSize.conversion > this.$env_var.fileSize.individualSize ){
				this.individualSizeErrMsg = true
				
				document.getElementById(type).value = ''
			}else if(this.extensionAllw.indexOf(file.name.split('.')[1].toLowerCase()) == -1){ 
				this.extensionType = true
			}else{
				this.individualSizeErrMsg = false
				this.lengthErrMsg = false
				if(type){
					// console.log('type',type)
					this.documentsByName[docType].data.push({
						'file':file,
						'name':file.name,
						'fileName' : this.fileName,
						'type' : type
					})
					document.getElementById(type).value = ''
	        	}else{
					// console.log('type not found',type)
					this.documentsByName[docType].data.push({
						'file':file,
						'name':file.name,
						'fileName' : this.fileName
					})
					this.fileName = '';
	        	}
			}
			// document.getElementById(docType).value = ''
        },
		clearOld(){
			let docType = Object.keys(this.documentsByName)[this.showTab]
			this.documentsByName[docType].data = []
			// this.documentsByName[docType].data = [{ 'name': '', 'file': '' }]
			// this.faliNameChange();
		},
		deleteFunc(getData1, docId){
			if(this.pageLoader){return;}
			let input_json={
				'globalParams' :{
					'id' : docId
				},
				'localParams' :{ "parameter" : this , 'getData' : getData1}
			}
			this._runDelDoc(input_json)
		},
		openCam(){
			this.isCameraOpen = true;
			this.docValidation = false
            this.createCameraElement();
		},
		closeCam(){
			this.isCameraOpen = false;
			this.isPhotoTaken = false;
			this.isShotPhoto = false;
			this.upload_options = true;
			this.stopCameraStream();
			this.documentsByName.Photo_Verification.data[0].name = ''
			this.documentsByName.Photo_Verification.data[0].file = ''
			this.documentsByName.Photo_Verification.data[0].fileName = ''
		},
		createCameraElement() {
			this.noCamera = false;
			this.cameraNotAllow = false;
            this.isLoading = true;
            this.timer = 0;
            let _that = this
            const constraints = (window.constraints = {
                audio: false,
                video: true
            });
            navigator.mediaDevices.getUserMedia(constraints).then(stream => {
                this.isLoading = false;
				try {
					this.$refs.camera.srcObject = stream;
				} catch (error) { }
            })
            .catch(error => {
                this.isLoading = false;
                this.isCameraOpen = false;
                this.file_upload = true;
                if(error.toString().includes('Permission denied')){
                	this.cameraNotAllow = true;
                }else{
                	this.noCamera = true;
                }
            	// console.log('image error',error,typeof(error),Object.keys(error),error.toString(),error.toString().includes('Permission denied'))
                // alert("May the browser didn't support or there is some errors. so please upload file");
            });
		},
		stopCameraStream() {
			try {
				let tracks = this.$refs.camera.srcObject.getTracks();
				tracks.forEach(track => {
					track.stop();
				});
			} catch (error) { }
		},
		countDown(){
			var timeleft = 5;
			var _that = this;
			var downloadTimer = setInterval(function(){
				if(timeleft <= 0){
					clearInterval(downloadTimer);
					_that.takePhoto()
				}
				_that.timer = timeleft;
				timeleft -= 1;
			}, 1000);
		},
		takePhoto() {
            if (!this.isPhotoTaken) {
                this.isShotPhoto = true;

                const FLASH_TIMEOUT = 50;

                setTimeout(() => {
                    this.isShotPhoto = false;
                }, FLASH_TIMEOUT);
            }
            if(this.documentsByName['Photo_Verification'].data.length == 0){
            	this.documentsByName['Photo_Verification'].data.push({ 'name': '', 'file': '' })
            }
            this.isPhotoTaken = !this.isPhotoTaken;
            const context = this.$refs.canvas.getContext('2d');
			context.drawImage(this.$refs.camera, 0, 0,200,200);
			let _that = this
			const canvas = document.getElementById('photoTaken');
			try{
				canvas.toBlob(function(blob) {
					_that.documentsByName['Photo_Verification'].data[0]['name']= 'Photo_Verification.png'
					_that.documentsByName['Photo_Verification'].data[0]['file'] = blob
					_that.documentsByName['Photo_Verification'].data[0]['fileName'] = 'Photo_Verification'
					// _that.file4 = blob;
				});
			}catch(e){
				console.log(e);
				var blob = $('#photoTaken').imageBlob().blob();
				_that.documentsByName['Photo_Verification'].data[0]['name']= 'Photo_Verification.png'
				_that.documentsByName['Photo_Verification'].data[0]['file'] = blob
				_that.documentsByName['Photo_Verification'].data[0]['fileName'] = 'Photo_Verification'
			}
        },
		onFileChange(fieldName,file) {
			this.noCamera = false;
			this.cameraNotAllow = false;
			this.fileName = '';
			if( file.size / this.$env_var.fileSize.conversion > this.$env_var.fileSize.individualSize ){
				this.individualSizeErrMsg = true
				this.refs.ipv_document.value = ''
			}else if(fieldName == 'Photo_Verification'){
				this.documentsByName['Photo_Verification'].data.push({ 'name': '', 'file': '' })
				this.documentsByName['Photo_Verification'].data[0].name = file.name
				this.documentsByName['Photo_Verification'].data[0].file = file
				this.documentsByName['Photo_Verification'].data[0].fileName = 'Photo_Verification'
			}
		},
		backButton(){
			this.showTab -= 1;
			this.faliNameChange();
			this.docValidation = false;
		},
		faliNameChange(){
			// automaticaly selects the first document type also called in action file
			if(this.showTab != 2){
				// console.log(this.showTab,Object.keys(this.fileNames[Object.keys(this.fileNames)[this.showTab]])[0])
				this.fileName = Object.keys(this.fileNames[Object.keys(this.fileNames)[this.showTab]])[0]
			}else{
				this.fileName = ''
			}
		},
		submitIndividual(){
			if(this.pageLoader){return;}
			const _that = this
			_that.submitted = true;
			let formRequest = document.getElementById('individualForm');
			let form_name = new FormData();
			// if(this.isPhotoTaken && this.isCameraOpen){
			// 	this.documentJson['ipv_document'] = this.file4
			// }
			let fileSize = 0
			let docType = Object.keys(this.documentsByName)[this.showTab]
			let haveFiles = 0
			let filelength = this.documentsByName[docType].data.filter(val => val.name).length
			filelength += (this.documentJsonData[docType] != undefined) ? this.documentJsonData[docType].length : 0
			// console.log('file-name',docType,this.documentsByName[docType] )
			this.documentsByName[docType].data.forEach( item => {
				if(item.name != ''){
					if(item.type){
						// console.log('=>',item.fileName +'_'+ item.type.toUpperCase() + '.'+ item.name.split('.')[item.name.split('.').length -1])
						form_name.append('document[]', item.file, item.fileName +'_'+ item.type.toUpperCase() + '.'+ item.name.split('.')[item.name.split('.').length -1] );
					}else{
						form_name.append('document[]', item.file, item.fileName + '.'+ item.name.split('.')[item.name.split('.').length -1] );
					}
					haveFiles += 1;
					fileSize += item.file.size
				}
			});
			if(haveFiles > 0){
				// console.log('haveFiles =>',haveFiles)
				if( fileSize / 1048576 > 60 ){
					this.totalSizeErrMsg = true
					_that.$notify({
						group: 'foo',
						type: 'error',
						text: 'files size should be lesser then 60 MB',
						duration: 10000,
						closeOnClick: true
					});
				}else{
					this.totalSizeErrMsg = false
					this.individualSizeErrMsg = false
					form_name.append('documenttype', docType);
					let input_json={
						'globalParams' :{
							'form' : form_name
						},
						'localParams' :{ "parameter" : _that , type : 'form'}
					}
					if(_that.showTab == 2){
						input_json.localParams.step = '3'
						form_name.append('step', '3');
					}else if(_that.showTab == 1){
						input_json.localParams.otp_call = true
					}
					_that._runStep6(input_json)
					
				}
			}else if(filelength == 0){
				// console.log('filelength =>',filelength)
				this.docValidation = true
			}else{
				// console.log('filelength,haveFiles =>',filelength,haveFiles)
				if(_that.showTab == 2){
					// console.log('filelength------>',filelength)
					_that.$router.replace('/home')
				}else{
					this.showTab += 1
					this.faliNameChange();
					if(this.showTab == 2){
						this.ImageOtpSent()
					}
				}
			}
			/*if(this.brand_file_request != ''){
				let file4 = document.getElementById("brand_file_request").files[0]
				form_name.append('document[]', file4, 'ipv_document.'+ this.brand_file_request.split('.')[this.brand_file_request.split('.').length -1]);
			}
			if(this.isPhotoTaken && this.isCameraOpen){
				form_name.append('document[]', this.file4, 'ipv_document.png');
			}
			
			if(this.documentJson['brand_file_request'] != ''){
				form_name.append('step', '3');
			}*/
			this.stopCameraStream()
		},
		ContinueMobileBrowser(getData) {
			this.continueMobileOption = getData
			this._runstateLoad({'globalParams' :{},'localParams' :{ "parameter" : this , 'page' :'individual_doc_step'}})
		},
		tierFunc(){
			if(parseInt(this.get_user.tier) == 2){
				this.$router.replace({ name: "support", params: {tabName:'openRequest',page :'view_dash'}})
			}
		},
		stepInfo(){
			
			this._runGetStepInfo({'globalParams' :{"step" : '3'},'localParams' :{ "parameter" : this}})
		}
	},
	created(){
		this.stepInfo()
		this.documentsByName['Photo_Verification'].data.push({ 'name': '', 'file': '' })
	}
}
</script>



// WEBPACK FOOTER //
// src/components/website/registerSteps/individual/individual_step3.vue